import script from "./EducationItemEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationItemEditor.vue?vue&type=script&setup=true&lang=js"

import "./EducationItemEditor.vue?vue&type=style&index=0&id=4e2e26a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e2e26a2"]])

export default __exports__